import PlantBusinessView from './PlantBusinessView';

export default PlantBusinessView;
